type TranslateFn = (key: string) => string;

const GENERAL_SECTION_ALIASES = new Set([
    'general',
    'generalfood',
    'כללי',
    'מצרכים כלליים',
    'מזון כללי',
]);

const CANONICAL_SECTION_KEYS = [
    'general',
    'meat',
    'vegetables',
    'fruits',
    'dairy',
    'cleaning',
    'toiletries',
    'canned',
    'pantry',
    'generalFood',
    'frozen',
    'bakery',
    'beverages',
    'other',
    'others',
] as const;

type CanonicalSectionKey = (typeof CANONICAL_SECTION_KEYS)[number];

const CANONICAL_LOOKUP = new Map<string, CanonicalSectionKey>(
    CANONICAL_SECTION_KEYS.map((key) => [key.toLowerCase(), key]),
);

/** Map stored section values (English, Hebrew, etc.) to a canonical key for grouping. */
export function toCanonicalSectionKey(section: string | undefined, t: TranslateFn): string {
    if (!section) return 'general';

    const trimmed = section.trim();
    const lower = trimmed.toLowerCase();

    if (GENERAL_SECTION_ALIASES.has(lower) || trimmed === t('general')) {
        return 'general';
    }

    const byEnglish = CANONICAL_LOOKUP.get(lower);
    if (byEnglish) return byEnglish;

    for (const key of CANONICAL_SECTION_KEYS) {
        if (trimmed === t(key)) return key;
    }

    return trimmed;
}

/** Normalize for grouping/comparison (legacy helper used by ShoppingCartDetailsModal). */
export function normalizeSectionKey(section: string | undefined, t: TranslateFn): string {
    return toCanonicalSectionKey(section, t);
}

/** Display a section name in the user's language. */
export function getSectionDisplayName(name: string, t: TranslateFn): string {
    const canonical = toCanonicalSectionKey(name, t);
    const lower = canonical.toLowerCase();

    if (CANONICAL_LOOKUP.has(lower)) {
        const key = CANONICAL_LOOKUP.get(lower)!;
        const trans = t(key);
        return trans !== key ? trans : name;
    }

    return name;
}
